import L from 'leaflet'
import markerIconPng from 'leaflet/dist/images/marker-icon.png'
import markerShadowPng from 'leaflet/dist/images/marker-shadow.png'

// Fix Leaflet's default icon path for Webpack/Vite bundlers
export const configureLeaflet = () => {
    delete (L.Icon.Default.prototype as any)._getIconUrl
    L.Icon.Default.mergeOptions({
        iconUrl: markerIconPng,
        shadowUrl: markerShadowPng,
    })
}
